import React from 'react';
import { cn } from '../lib/utils';

const SponsorLogo = ({ className, imgClassName, alt = 'Bozar' }) => {
  return (
    <div className={cn('flex justify-center items-center text-white', className)}>
      <svg
        role="img"
        aria-label={alt}
        viewBox="18 236 606 168"
        className={cn('block w-full h-full', imgClassName)}
      >
        <title>{alt}</title>
        <path
          fill="currentColor"
          d="M21.5,400.4V239.6h64.8c16.7,0,30,3.7,40,11.1c10,7.4,14.9,18,14.9,31.8c0,8.3-2.6,15.2-7.8,20.8
          c-5.2,5.6-11.6,9.6-19.3,12.1v1.6c8.7,2,16.3,6.1,22.8,12.2c6.4,6.1,9.7,14.6,9.7,25.3c0,14.4-5.2,25.7-15.6,33.8
          c-10.4,8.1-23.7,12.2-40,12.2H21.5z M54.8,304.8h29.6c16.1,0,24.1-6.4,24.1-19.1c0-12.7-8-19.1-24.1-19.1H54.8V304.8z M54.8,373.3
          h31.3c17.6,0,26.4-7.2,26.4-21.6c0-14.6-8.8-21.8-26.4-21.8H54.8V373.3z M178.5,385.7c-11.3-11.6-17-26.3-17-43.9
          c0-17.6,5.7-32.2,17-43.9c11.3-11.6,25.7-17.5,43.2-17.5c17.3,0,31.6,5.8,42.7,17.5c11.2,11.6,16.8,26.3,16.8,43.9
          c0,17.8-5.6,32.4-16.7,44c-11.1,11.6-25.3,17.3-42.6,17.3C204.3,403.2,189.8,397.4,178.5,385.7z M193.2,341.8
          c0,24.5,9.5,36.8,28.5,36.8c9.3,0,16.3-2.9,20.9-8.8c4.6-5.9,6.9-15.2,6.9-27.9c0-11.9-2.3-21.1-7-27.3c-4.7-6.3-11.6-9.4-20.8-9.4
          c-9.3,0-16.4,3.1-21.3,9.4C195.6,320.8,193.2,329.9,193.2,341.8z M295.9,376.1l58.6-66.4V308h-56.1v-24.8h96.1V308l-57.2,66v1.6
          h60.2v24.8H295.9V376.1z M489.6,400.2v-31h-0.9c-8,12.9-15,21.8-21.1,26.7c-6.1,4.9-13.9,7.4-23.4,7.4c-9.7,0-17.5-2.9-23.6-8.8
          c-6.1-5.9-9.1-13.6-9.1-23.1c0-19.9,12-32.9,36.1-38.8l41.8-10.3v-2.8c0-4.9-1.7-8.8-5.2-11.6c-3.4-2.8-8.5-4.2-15.3-4.2
          c-7.2,0-12.9,1.5-17,4.4c-4.1,2.9-6.2,7.2-6.2,12.9h-30.3c0-12.9,4.8-22.8,14.4-29.8c9.6-7,22.6-10.5,39.2-10.5
          c16.5,0,29,3.8,37.3,11.4c8.3,7.6,12.5,18.3,12.5,32.3v76.1H489.6z M441.4,367.3c0,3.2,1.1,5.8,3.2,7.7c2.1,1.9,4.9,2.9,8.3,2.9
          c5.2,0,10.6-2.4,16.2-7.4c5.6-4.9,12.4-12.9,20.3-24.1v-6L457.5,351C446.7,354.5,441.4,360,441.4,367.3z M542.9,400.4V283.2h29.6
          v29.2h1.6c2.8-9.5,7.6-17.2,14.5-23c6.9-5.8,15.6-8.7,26.2-8.7h6.7v28.7h-6.9c-13.5,0-23.6,3.8-30.5,11.3
          c-6.8,7.5-10.2,17.7-10.2,30.6v49.2H542.9z"
        />
      </svg>
    </div>
  );
};

export default SponsorLogo;
